import { useAuth } from '@/auth/AuthProvider';
import { TOUR_STEPS } from '../constants';
import { useFirstAccessTour } from '../hooks/useFirstAccessTour';
import { TourOverlay } from './TourOverlay';

/**
 * Shows the guided tour on the authenticated user's first access to the app.
 */
export function FirstAccessTour() {
  const auth = useAuth();
  const tour = useFirstAccessTour(auth.user?.profile.sub, TOUR_STEPS);

  return tour.isOpen ? <TourOverlay {...tour} /> : null;
}
